import { Box, Button } from '@user-portal/wikr-components';
import styled from 'styled-components';

import MediaQueries from 'theme/mediaQueries';
import { color } from 'theme/selectors';

const ICON_WIDTH = '44px';

export const PauseModalContent = styled.div`
    height: 100%;
    padding: 32px 8px;
    overflow: hidden;
    background: ${({ theme }) => `${color('surface-main')}({ theme })`};

    ${MediaQueries.largeTablet} {
        padding: 32px 16px;
    }
`;

export const ModalHeaderTitle = styled.div`
    position: fixed;
    display: flex;
    justify-content: space-between;
    text-align: center;
    align-items: center;
    padding: 16px;
    background: ${color('surface-main')};
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    border-bottom: 1px solid ${color('border-default')};

    ${MediaQueries.laptop} {
        padding: 16px 40px;
    }
`;

export const TitleText = styled.div<{ $isLeftButton?: boolean }>`
    padding-left: ${({ $isLeftButton }) => ($isLeftButton ? 0 : ICON_WIDTH)};
    flex: 1;
`;

export const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${color('surface-secondary')};
    height: 44px;
    width: ${ICON_WIDTH};
    border-radius: 50%;

    &:hover {
        cursor: pointer;
    }
`;

export const ConfirmButton = styled(Button)`
    border: 1px solid ${color('border-default')};
    padding: 20px;
    color: ${color('border-default')};
    max-width: 100%;

    &&& {
        background-color: transparent;
    }

    &:hover {
        background-color: ${color('surface-hovered')} !important;
        color: ${color('surface-hovered')} !important;
    }
`;

export const PauseCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 20px;
    overflow: hidden;
    background: ${color('surface-default')};
    margin-bottom: 24px;
`;
export const CardHeader = styled.div`
    width: 100%;
    padding: 0 20px;
    background: ${color('safe')};
`;

export const CardBody = styled.div`
    padding: 20px 16px 16px 16px;
    width: 100%;
`;

export const PauseButton = styled(Button)`
    margin-top: 24px;
    width: 100%;
`;

export const DetailsList = styled.ul`
    padding-left: 0;

    li {
        margin-bottom: 12px;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export const InfoBlock = styled(Box)`
    display: flex;
    gap: 5px;

    align-items: baseline;

    svg {
        width: 16px;
        min-width: 16px;
    }
`;
